import ReportToggleField from "./fields/ReportToggleField.vue"
import ReportSelectField from "./fields/ReportSelectField.vue"
import ReportTextField from "./fields/ReportTextField.vue"
import ReportNumberField from "./fields/ReportNumberField.vue"
import ReportTimeField from "./fields/ReportTimeField.vue"
import ReportDateField from "./fields/ReportDateField.vue"
import ReportStaticField from "./fields/ReportStaticField.vue"
import ReportProseField from "./fields/ReportProseField.vue"
import ReportRepeaterField from "./fields/ReportRepeaterField.vue"
import ReportOptionCardsField from "./fields/ReportOptionCardsField.vue"

/**
 * Field type registry for schema-driven report settings.
 *
 * The renderer (ReportSettingsPanel) resolves a field to a component through
 * this map, so adding a new input type never requires editing the renderer --
 * add a component and register it here (or call registerFieldType at runtime).
 *
 * A field type component receives:
 *   :model-value  the current value for the field's settings key
 *   :field        the schema entry (label, description, and any type-specific keys)
 *   :timezone     the company timezone, for date/time types
 *   :error        a validation message, if the server returned one
 * and emits `update:modelValue` with the new value.
 */
export const FIELD_TYPES = {
    toggle: ReportToggleField,
    select: ReportSelectField,
    // A multiselect is a select with `multiple` forced on by the panel, so the
    // two share one component rather than duplicating the select2 wiring.
    multiselect: ReportSelectField,
    text: ReportTextField,
    number: ReportNumberField,
    time: ReportTimeField,
    date: ReportDateField,
    static: ReportStaticField,
    prose: ReportProseField,
    repeater: ReportRepeaterField,
    // A describe-then-pick choice as selectable cards (title + description +
    // radio) instead of a dropdown. Reads/writes a settings key like `select`.
    optioncards: ReportOptionCardsField,
}

// Field types that display derived or explanatory content and therefore never
// read or write a settings key.
export const READ_ONLY_FIELD_TYPES = ['static', 'prose']

export const registerFieldType = (name, component) => {
    FIELD_TYPES[name] = component
}

export const resolveFieldType = (type) => FIELD_TYPES[type] ?? null
